import { render, staticRenderFns } from "./AddAndEdit.vue?vue&type=template&id=aa4b6d3e&scoped=true&"
import script from "./AddAndEdit.vue?vue&type=script&lang=js&"
export * from "./AddAndEdit.vue?vue&type=script&lang=js&"
import style0 from "./AddAndEdit.vue?vue&type=style&index=0&id=aa4b6d3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4b6d3e",
  null
  
)

export default component.exports